import { render, staticRenderFns } from "./OverlayFullScreenImage.vue?vue&type=template&id=1861c2bc&scoped=true"
import script from "./OverlayFullScreenImage.vue?vue&type=script&lang=js"
export * from "./OverlayFullScreenImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861c2bc",
  null
  
)

export default component.exports